import React, {ButtonHTMLAttributes} from 'react';
import {StyledButton, IconContainer} from './styled';
import StyledIcon from 'components/acommon/StyledIcon';

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  label: React.ReactNode | string;
  icon?: React.ReactNode;
  iconname?: string;
  iconRight?: string;
  short?: boolean;
  secondary?: boolean;
  whiteButton?: boolean;
  blackButton?: boolean;
};

const defaultProps: ButtonProps = {
  label: '',
  short: false,
  type: undefined,
  icon: null,
  iconname: '',
  iconRight: '',
  secondary: false,
  whiteButton: false,
  blackButton: false,
};

function Button({
  icon,
  iconname,
  iconRight,
  label,
  short,
  disabled,
  className,
  type,
  ...props
}: ButtonProps) {
  return (
    <StyledButton
      short={short}
      disabled={disabled}
      className={className}
      type={type}
      {...props}
    >
      {iconname ? (
        <IconContainer>
          <StyledIcon name={iconname} />
        </IconContainer>
      ) : (
        icon && <IconContainer>{icon}</IconContainer>
      )}
      <span className="buttonLabel">{label}</span>
      {!!iconRight && (
        <span className="iconRight">
          <StyledIcon name={iconRight} size="24" />
        </span>
      )}
    </StyledButton>
  );
}

Button.defaultProps = defaultProps;
export {Button};
export default Button;
